import {z} from 'zod';
import {BankDetails} from './bank-details';
import {Date} from './date';
import {Dealer} from './dealer';
import {DelayOfPayment} from './delay-of-payment';
import {PaymentPlan} from './payment-plan';
import {PersonalData} from './personal-data';
import {Vehicle} from './vehicle';

export const Contract = z.object({
  oid: z.number(),
  contractNumber: z.string(),
  startDate: Date,
  endDate: Date,
  brand: z.number(),
  vehicle: Vehicle.nullable(),
  active: z.boolean(),
  currentBalance: z.number(),
  dealer: Dealer.nullable(),
  terminationDates: z.array(Date).nullable(),
  bankDetails: BankDetails.nullable(),
  restricted: z.boolean(),
  type: z.number(),
  hasCredit: z.boolean(),
  contractor: PersonalData.nullable(),
  nextInstallment: z.number(),
  lastInstallment: z.number(),
  nextInstallmentDate: Date.nullable(),
  hasCollateral: z.boolean(),
  arrears: z.number(),
  hasArrears: z.boolean(),
  hasBalloonPayment: z.boolean(),
  application: z.boolean(),
  term: z.number(),
  numberOfPaidInstallments: z.number(),
  zeroPercentInterest: z.boolean(),
  hasActiveDeferments: z.boolean(),
  nextDefermentAllowedDate: Date.nullable(),
  numberOfDeferments: z.number(),
  statusDunning: z.number(),
  delayOfPayment: DelayOfPayment.nullable(),
  paymentPlan: z.array(PaymentPlan),
  numberOfOpenInstallments: z.number(),
  hasRequestedDelayOfPayment: z.boolean(),
  tcmToko: z.boolean(),
  balloonPaymentAlreadyDeferred: z.boolean(),
  installmentDates: z.array(Date),
  installmentDateChangedToday: z.boolean(),
  nextPossiblePaymentDateChange: Date.nullable(),
  defermentToday: z.boolean(),
  serviceContract: z.boolean(),
  serviceComponents: z.array(z.string()).nullable(),
  vehicleLetterAvailable: z.boolean(),
  rsvLrv: z.boolean(),
  returnDate: Date.nullable(),
  hasDunningLock: z.boolean(),
  rsvHasBestAger: z.boolean(),
  hatRsvLrvPlus: z.boolean(),
});

export type Contract = z.infer<typeof Contract>;
